var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section page__footer"},[(_vm.isVisible)?_c('VPagination',{attrs:{"pages":_vm.pagination.pages,"currentPage":_vm.pagination.currentPage},on:{"get-page":_vm.loadPage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }